import React, { useEffect, useState } from "react";

import { Text, View } from "react-native";
import { globalFontStyle } from "../assets";
import { check, errorBlock, warning } from "../utils/images";
import FastImage from "./FastImage";
import Colors from "../assets/Color/Colors";

function ShowError({ error, customStyle }) {
  return (

    <View style={[{ flexDirection: "row", marginTop: 5 }, customStyle]}>
      {error?.errorClass?.color === Colors.red ? (
        <FastImage
          style={{ width: 15, height: 15 }}
          source={warning()}
        />
      ) : (
        <FastImage style={{ width: 15, height: 15 }} source={check()} />
      )}
      <Text
        style={[
          { ...globalFontStyle.appFontSubText, marginLeft: 5 },
          error?.errorClass ? error.errorClass : null,
        ]}
      >
        {error?.message}
      </Text>
    </View>
  );
}

export default ShowError;
